"use client";
import cn from "classnames";
import React, { useEffect, useState, useMemo, useRef } from "react";
import { fetchCMS } from '@/lib/cms';
import { CmsYouTubeType } from "@/state/music";
import { VideoPlayerHandle } from "@/lib/yt";
import VideoPlayer from "@/components/VideoPlayer";
import TextCycler from "@/components/ui/TextCycler";
import { Button } from '@/components/forms/index'
import Styles from "./page.module.scss";

type bullet = { id: string; text: string }

type ContentType = {
  bullets: bullet[];
  video: CmsYouTubeType;
  cta: string;
} | null;

const Home = () => {
  const [contactActive] = useState(false);
  const [content, setContent] = useState<ContentType>(null);
  const [isReady, setIsReady] = useState(false);

  const videoOptions = useMemo(() => ({
    playerVars: {
      mute: 1,
      start: content?.video?.start,
      end: content?.video?.end,
    },
  }), [content?.video?.start, content?.video?.end]);

  const fetchAndUpdateState = async () => {
      const { data } = await fetchCMS('homepage', { populate: '*', normalize: true });
      if (!data || typeof data !== 'object') return;

      const obj = data as Record<string, unknown>;

      setContent({
        bullets: (obj.bullets as bullet[]),
        video: (obj.video as CmsYouTubeType) ?? { vid: '', start: 0, end: 0 },
        cta: (obj.cta as string) ?? "",
      });
    };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      fetchAndUpdateState();
    }
    return () => { mounted = false; };
  }, []);

  const videoRef = useRef<VideoPlayerHandle | null>(null);

  return (
    <section className={Styles.hero}>
      <div
        className={cn(Styles.videoContainer, { isReady })}
        aria-hidden={!isReady}
      >
        <VideoPlayer
          ref={videoRef}
          ariaHidden={true}
          onFirstFrame={() => setIsReady(true)}
          videoId={content?.video?.vid || ""}
          options={videoOptions}
          className={Styles.videoIframe}
        />
      </div>

      <div className={cn(Styles.overlay, { contactActive })}>
        <div className={Styles.bullets}>
          <TextCycler
            delay={4000}
            className={Styles.textCycler}
            items={content?.bullets || []}
          />
          <Button
            size="xl"
            variant="primary"
            klass={Styles.joinButton}
            href="/apply"
            value={content?.cta}
          />
        </div>

        <div className={Styles.logo}>
          <p>CR</p>
        </div>

      </div>
    </section>
  );
}

export default Home;
